export default __webpack_public_path__ + "static/media/coffee.986abd6c.jpeg";